import React from 'react';
import Tooltip from './Tooltip';
import TooltipStatic from './TooltipStatic';
import Assets from '../../Assets';

export default class Warning extends React.Component {
    static GetIcon = color => {
        switch (color) {
            case 'red':
                return Assets.warningRed;
            case 'blue':
                return Assets.warningBlue;
            case 'orange':
                return Assets.warningOrange;
            case 'gray':
                return Assets.warningGray;
        }
    }

    static CreateWarning = (text, color) => {
        return <Warning warning={{text, color}}/>
    }

    render() {
        if (!this.props.warning) {
            return <React.Fragment/>
        }

        const icon = Warning.GetIcon(this.props.warning.color);
        if(this.props.warning.isStatic)
            return <TooltipStatic icon={icon} style={this.props.warning.color} text={this.props.warning.text}/>
        return <Tooltip icon={icon} style={this.props.warning.color} text={this.props.warning.text}/>
    }
}